import { getCurrencySymbol } from '@gameday/common/functions/currency'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'
import AlertMessage from '../AlertMessage'

const StyledAppliedDiscounts = styled.div`
  width: 100%;
  padding: ${rem(18)} 0 ${rem(18)};
  border-top: ${theme.borders.default};

  & > div + div {
    margin-top: ${rem(10)};
  }
`

const AppliedDiscounts = ({ appliedDiscounts, currencyCode }) => {
  if (appliedDiscounts.length === 0) {
    return null
  }

  return (
    <StyledAppliedDiscounts>
      {appliedDiscounts.map(discount => {
        const { id, name, summary } = discount
        const { products, registrationCount, totalAmount } = summary
        return (
          <AlertMessage key={id} variant="success" title={name} show>
            Discount applied to products: {products.join(', ')}. This discount has been applied across{' '}
            {registrationCount} registration
            {registrationCount > 1 ? 's' : ''}.
            <br />
            <strong>
              You are receiving a discount of {getCurrencySymbol(currencyCode)}
              {totalAmount.toFixed(2)}
            </strong>
          </AlertMessage>
        )
      })}
    </StyledAppliedDiscounts>
  )
}

AppliedDiscounts.defaultProps = {
  appliedDiscounts: [],
  currencyCode: 'AUD',
}

export default AppliedDiscounts
